import api from '../../../config/axios'
import type { SensorType } from '../../../types'
import type {
  PaginatedSensorTypes,
  SensorTypeFilters,
  SensorTypeOptionsParams,
  SensorTypeOptionsResponse,
} from '../../../types/api'
import { API } from '../../../config/links';

export const SensorTypeService = {
  list: (filters?: SensorTypeFilters) =>
    api
      .get<PaginatedSensorTypes>(API.sensorTypes.list, {
        params: { ...(filters || {}) },
      })
      .then((res) => res.data),

  /** Convenience wrapper — returns items only (legacy call sites). */
  getAll: (filters?: SensorTypeFilters) =>
    SensorTypeService.list({
      limit: 1000,
      is_active: true,
      ...(filters || {}),
    }).then((res) => res.items),

  getOptions: (params: SensorTypeOptionsParams) => {
    const { exclude_categories, ...rest } = params
    return api
      .get<SensorTypeOptionsResponse>(API.sensorTypes.options, {
        params: {
          ...rest,
          ...(exclude_categories?.length
            ? { exclude_categories }
            : {}),
        },
        paramsSerializer: (p) => {
          const search = new URLSearchParams()
          Object.entries(p).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '') return
            if (Array.isArray(value)) {
              value.forEach((item) => search.append(key, String(item)))
            } else {
              search.append(key, String(value))
            }
          })
          return search.toString()
        },
      })
      .then((res) => res.data)
  },

  getById: (id: string) =>
    api.get<SensorType>(API.sensorTypes.byId(id)).then((res) => res.data),

  create: (data: Partial<SensorType>) =>
    api.post<SensorType>(API.sensorTypes.list, data).then((res) => res.data),

  update: (id: string, data: Partial<SensorType>) =>
    api.put<SensorType>(API.sensorTypes.byId(id), data).then((res) => res.data),

  delete: (id: string) => api.delete(API.sensorTypes.byId(id)),
}